// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FAQ_link__3GRnF {\n  font-size: var(--landing-font-size-mail);\n}\n.FAQ_content__30a2f {\n  max-width: 56rem;\n  margin-top: 3rem;\n  position: relative;\n}\n", "",{"version":3,"sources":["webpack://src/Landing/Components/FAQ.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".link {\n  font-size: var(--landing-font-size-mail);\n}\n.content {\n  max-width: 56rem;\n  margin-top: 3rem;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "FAQ_link__3GRnF",
	"content": "FAQ_content__30a2f"
};
export default ___CSS_LOADER_EXPORT___;
